/* eslint-disable react-hooks/exhaustive-deps */
import {
	Box,
	Spinner,
	Flex,
	Button,
	HStack,
	InputGroup,
	InputRightElement,
	Center,
	Icon,
} from '@chakra-ui/react'
import React, { useRef, useCallback, useEffect, useState } from 'react'
import { useAuthContext } from '../../context/auth.context'
import { useSharedContext } from '../../context/shared.context'
import {
	useLoadTimelineList,
	useLoadTimelineSearch,
} from '../../hooks/activity.hooks'
import { AiOutlineClose } from 'react-icons/ai'
import { sharedConst } from '../../utils/action.constant'
import TimelineComponents from './components'
import { TIMELINE_MESSAGE_TYPE } from './util'
import bgImage from '../../assets/images/opaque_bgImage.png'
import { formatDDMMYYYY } from './../../utils/date.utils'
import { WhatNext } from '../whatNext'
import { MdSearch } from 'react-icons/md'
import InputText from '../globalComponents/inputText'
import { useLanguageContext } from '../../context/locale.context'

/**
 * //TODO: Load new timeline on load more and put it in reverse order
 * //TODO: Listen to push notification and pull the latest timeline event again and append at last.
 * //TODO: On mount set unread count for an activity to 0
 *
 */

const Timeline = ({
	activity,
	filter = {
		value: TIMELINE_MESSAGE_TYPE.ALL,
		label: 'All',
	},
	onFormSelection,
	timelineReplyData = () => null,
	searchView,
	setSearchView,
}) => {
	const {
		state: {
			isRefreshTimeline,
			random,
			asset_notification_muted,
			showWhatsNext,
		},
		dispatch,
	} = useSharedContext()
	const messageEndRef = useRef(null)
	const msgDiv = useRef(null)
	const [search_string, setSerachString] = useState('')
	const [data, setdata] = useState(null)
	const [isLoading, setisLoading] = useState(false)

	const { mutate } = useLoadTimelineList()
	const { mutate: timelineSearchMutate } = useLoadTimelineSearch()
	const {
		state: { authData },
	} = useAuthContext()
	const {
		state: { locale },
	} = useLanguageContext()
	const { activity_creator_asset_id, activity_lead_asset_id } = !!activity
		? activity
		: {}

	const { asset_id } = authData

	const what_next_access = [
		activity_creator_asset_id,
		activity_lead_asset_id,
	].includes(asset_id)
		? activity_creator_asset_id === asset_id && !activity_lead_asset_id
			? true
			: activity_lead_asset_id === asset_id
		: false

	const onScrollDown = () => {
		setTimeout(() => {
			messageEndRef?.current?.scrollIntoView({
				behavior: 'smooth',
			})
		}, 500)
	}

	const timelineScroll = id => {
		var elmnt = document.getElementById(id)
		if (elmnt) {
			elmnt.focus()
			elmnt.scrollIntoView({ behavior: 'smooth' })
		}
	}

	const onSuccess = (res, isLatest) => {
		setisLoading(false)
		const { list, ...rest } = res
		if (!data || !Object.keys(data).length) {
			setdata({
				...rest,
				list: list.reverse(),
			})
			onScrollDown()
		} else {
			if (!!isLatest) {
				setdata({
					...rest,
					list: [...list.reverse()],
				})
				onScrollDown()
			} else {
				setdata({
					...rest,
					list: [...list.reverse(), ...data.list],
				})
				if (searchView) {
					setdata(null)
					setdata({
						list: [...data.list],
					})
				}

				//timelineScroll(`reply_item${data.list[0].timeline_transaction_id}`);
				msgDiv?.current?.scrollTo(0, 60)
			}
		}
	}

	const loadTimeline = useCallback(
		({ activity, start = 0, isLatest = false }) => {
			setisLoading(true)
			mutate(
				{
					activity_id: activity.activity_id,
					activity_type_category_id: activity.activity_type_category_id,
					file_unread_count: activity.asset_unread_updates_count,
					flag_previous: -2,
					page_start: !!isLatest ? 0 : start,
					page_limit: 20, //activity.asset_unread_updates_count load only unread details
					datetime_differential: 0,
					timeline_transaction_id: 0,
					sort_flag: 0,
					sort_order: 0,
				},
				{
					onSuccess: res => {
						onSuccess(res, isLatest)
					},
				}
			)
		}
	)

	useEffect(() => {
		if (!data || (!Object.keys(data).length && !isLoading)) {
			loadTimeline({ activity })
		}
	}, [data])

	useEffect(() => {
		if (!!activity) {
			setdata(null)
		}
	}, [activity.activity_id])
	const loadSearchTimelineData = useCallback(search_string => {
		timelineSearchMutate(
			{
				activity_id: activity.activity_id,
				timeline_transaction_id: 0,
				search_string,
				is_previous: -4,
				is_search: 1,
				page_start: 0,
				page_limit: 20,
			},
			{
				onSuccess: async res => {
					setdata(res)
				},
			}
		)
	})
	useEffect(() => {
		if (!!search_string) {
			loadSearchTimelineData(search_string)
		} else {
			setdata(null)
		}
	}, [search_string])

	useEffect(() => {
		if (!!isRefreshTimeline || random) {
			dispatch({ type: sharedConst.RESET_REFRESH_TIMELINE })
			loadTimeline({ activity, isLatest: true })
		}
	}, [isRefreshTimeline, random])

	const onScroll = event => {
		var element = event.target
		if (element.scrollTop === 0 && data?.isMore) {
			loadTimeline({
				activity,
				start: data.page_start,
			})
		}
	}

	const showWhatsNextComponent = () => {
		if (
			showWhatsNext &&
			what_next_access &&
			activity?.activity_type_flag_enable_whatnext === 1 &&
			asset_notification_muted === 0 &&
			activity?.activity_id === data?.list?.[0]?.activity_id
		) {
			return <WhatNext scrollDown={onScrollDown} />
		}
		return null
	}

	const showTimelineComponents = () => {
		if (data && data.list) {
			let prevDate
			let showDate = true
			return data.list.map((timelineItem, index) => {
				let msgDate = formatDDMMYYYY(timelineItem.datetime_log)
				if (prevDate !== msgDate) {
					showDate = true
				} else {
					showDate = false
				}
				prevDate = msgDate
				return (
					<TimelineComponents
						filter={filter.value}
						showDate={showDate}
						onFormSelection={onFormSelection}
						{...authData}
						key={timelineItem.timeline_transaction_id}
						timeline={timelineItem}
						timelineReplyData={e => {
							timelineReplyData(e)
							onScrollDown()
						}}
						timelineScroll={timelineScroll}
					/>
				)
			})
		}
		return null
	}
	useEffect(() => {
		if (searchView) {
		} else {
			setdata(null)
			loadTimeline({ activity })
			onScrollDown()
		}
	}, [searchView])

	return (
		<>
			<Box
				backgroundImage={`url(${bgImage})`}
				backgroundRepeat='no-repeat'
				backgroundPosition='center'
				backgroundSize='cover'
				backgroundColor='#bbbbbb20'
				w='100%'
				h='100%'
			>
				{searchView && (
					<HStack>
						<Center width='50%' ml='25%'>
							<InputGroup marginTop='2' mb='2'>
								<InputText
									type='tel'
									width='100%'
									height='36px'
									fontSize='13px'
									fontStyle='normal'
									fontWeight='500'
									background='#FFFFFF'
									placeholder={locale['Enter Keyword']}
									value={search_string}
									onChange={e => {
										setSerachString(e.target.value)
									}}
									_placeholder={{
										color: '#BBBBBB',
										opacity: '0.5',
									}}
									borderRadius='18px'
									border='none'
									boxShadow='0px 0px 10px rgba(0, 0, 0, 0.1)'
								/>
								<InputRightElement
									pointerEvents='none'
									color='green.500'
									children={<MdSearch fontSize='25' />}
								/>
							</InputGroup>
							<Icon
								className={`status-activity-view-back-icon`}
								as={AiOutlineClose}
								cursor='pointer'
								color='red.600'
								w={5}
								h={5}
								ml='2'
								mt='2'
								onClick={() => {
									setSearchView(false)
									setSerachString('')
								}}
							/>
						</Center>
					</HStack>
				)}

				<Box
					ref={msgDiv}
					overflowY='scroll'
					h='100%'
					w='100%'
					px={1}
					onScroll={onScroll}
				>
					<Flex
						w='100%'
						justifyContent='center'
						alignItems='center'
						my={2}
						className={`timeline-section-scroll-view`}
					>
						{isLoading ? <Spinner color='brand.800' /> : null}
					</Flex>

					{(!searchView || search_string?.length > 0) &&
						showTimelineComponents()}
					{showWhatsNextComponent()}
					<div ref={messageEndRef} />
				</Box>
			</Box>
		</>
	)
}

export default Timeline
